import styled from 'styled-components';

import { DialogMemo } from 'components/dialog';

export const StyledDialog = styled(DialogMemo)`
  h2 {
    padding: 0 1rem;
  }
`;

export const StyledGearIcon = styled.div`
  margin: 0.625rem auto;
  display: inline-block;
`;

export const ContentContainer = styled.div`
  padding: 0 1rem;
  text-align: center;
`;

export const ModalHeading = styled.span`
  max-width: 10rem;
  text-align: center;
`;

export const ModalBody = styled.p`
  font-family: ${Styles.fontFamily.body};
  font-size: 1rem;
  text-align: center;
  max-width: 20rem;
  margin: auto;
`;
